export default __webpack_public_path__ + "static/media/query-stats-icon.6fa9d0db.svg";